import axios from 'axios'
import {Notify} from "vant";
// 创建axios实例
const instance = axios.create({
    baseURL: "https://6api.itooi.cn/", // api 的 base_url
    // baseURL: "http://127.0.0.1:8081/", // api 的 base_url
    timeout: 6000, // 请求超时时间
})

// request拦截器
instance.interceptors.request.use(
    config => {
        config.headers['Content-Type'] = 'application/json'
        return config
    },
    error => {
        // Do something with request error
        console.log(error) // for debug
        Promise.reject(error)
    }
)

// response 拦截器
instance.interceptors.response.use(
    response => {
        const code = response.status
        if (code < 200 || code > 300) {
            Notify({
                message: '请求出错，请重新从公众号获取链接',
                type: 'warning'
            })
            return Promise.reject('error')
        } else {
            return response.data
        }
    },
    error => {
        Notify({
            message: '请求出错，请重新从公众号获取链接',
            type: 'danger'
        })
        return Promise.reject(error)
    }
)
export default instance
